import { DataBean } from "../DataBean";

export class WorkActivityGroup extends DataBean {

  public async getWorkActivityGroupCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getWorkActivityGroupCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getGroupsByAccount(idAccount: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getGroupsByAccount_Number",
      [idAccount]
    );
  }

  public async getGroupsByWorkActivity(IDWorkActivity: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getGroupsByWorkActivity_Number",
      [IDWorkActivity]
    );
  }

  public async getGroupsBySprint(IDSprint: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getGroupsBySprint_Number",
      [IDSprint]
    );
  }

  public async deleteWorkActivityGroup(idworkactivitygroup: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteWorkActivityGroup_Number",
      [idworkactivitygroup]
    );
  }

  public async updateWorkActivityGroup(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivityGroup_updateWorkActivityGroup_com.advantage.processflow.bean.WorkActivityGroup",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.processflow.bean.WorkActivityGroup",
        },
      ]
    );
  }
}
